<template>
  <div class="container">
    <div class="heading">跳转统一登录</div>
    <p class="desc">正在请求统一认证网关，如果没有自动跳转，可以手动重试。</p>
    <a-button type="primary" size="large" class="login-button" @click="goLogin">
      重新发起登录
    </a-button>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'
import { redirectToGatewayLogin } from '@/utils/auth'

export default defineComponent({
  name: 'GatewayLogin',
  setup() {
    const goLogin = () => {
      redirectToGatewayLogin()
    }
    onMounted(() => {
      goLogin()
    })

    return {
      goLogin,
    }
  },
})
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.heading {
  font-weight: 700;
  font-size: 28px;
  color: #333;
  margin-bottom: 18px;
}

.desc {
  color: #666;
  line-height: 1.7;
  margin-bottom: 24px;
}

.login-button {
  width: 100%;
  height: 45px !important;
}
</style>
